import React from "react"
import styled from "@emotion/styled"
import { Flex } from "@rebass/grid/emotion"

import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"
import ArrowSVG from "../../../../../assets/icons/nova/arrow-left.svg"

const Arrow = styled(Flex)`
  align-items: center;
  justify-content: center;
  background: ${theme.wild.color.nova.base.solid[40]};
  border-radius: 2px;

  svg {
    height: 66.667%;
    width: 66.667%;
  }

  &.next {
    transform: rotate(180deg);
  }
`

export const NextArrow = ({ onClick, width, height }) => {
  return (
    <Arrow
      as="button"
      onClick={onClick}
      className="next"
      width={width ? width : 24}
      height={height ? height : 24}
    >
      <ArrowSVG />
    </Arrow>
  )
}

export const PrevArrow = ({ onClick, width, height }) => {
  return (
    <Arrow
      as="button"
      onClick={onClick}
      className="prev"
      width={width ? width : 24}
      height={height ? height : 24}
    >
      <ArrowSVG />
    </Arrow>
  )
}
